import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../models/data';

type UserState = {
  user: User;
};

const initialState: UserState = {
  user: {
    id: '',
    name: '',
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      // Merge rather than replace: several endpoints (profiles, name/display-name
      // PATCH, etc.) return a user shape that omits fields like `building` or
      // `avatar_url`. A hard replace here wiped those out, which is why the
      // /my "Set default" star kept disappearing after visiting other pages.
      state.user = { ...state.user, ...action.payload };
    },
    setUserBuilding(state, action: PayloadAction<{ buildingId: string }>) {
      state.user.building = { id: action.payload.buildingId };
    },
    setUserAvatar(state, action: PayloadAction<{ avatarUrl: string | null }>) {
      state.user.avatar_url = action.payload.avatarUrl;
    },
    clearUser(state) {
      state.user = {
        id: '',
        name: '',
      };
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
